module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.ttf?e18bbf611f2a2e43afc071aa2f4e1512";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/bootstrapv3/fonts/glyphicons-halflings-regular.ttf
// module id = 589
// module chunks = 0